<script>
import { Pie } from 'vue-chartjs'
export default {
    name: 'salesPayment',
    extends: Pie,
    props: [
        'options',
        'chartData'
    ],
    mounted () {
        this.renderChart(this.chartData, this.options)
    }
}
</script>
<style scoped>

</style>